export default "__VITE_ASSET__ab7acd8e__"